import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap'
import '../App.css'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSearchParams } from 'react-router-dom'
import regions from '../JSON/regions.json';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';


import { getMonth, getYear } from 'date-fns';
import range from "lodash/range";


import { min } from 'moment';




const NavRight = ({ getParams, region }) => {
  const date = new Date();


  const UTCStartDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  const UTCEndDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), Math.floor(date.getUTCMinutes() / 60 + 1) * 60);
  const [searchParams, setSearchParams] = useSearchParams();


  const encodeSatellites = (satellites) => {
    return satellites.map(s => s ? '1' : '0').join('');
  };
  
  const decodeSatellites = (bitString) => {
    return bitString.split('').map(bit => bit === '1');
  };

  //initialize satellites from URL
  const [satellites, setSatellites] = useState(() => {
    const satellitesParam = searchParams.get('sats');
    const satelliteCount = Object.keys(regions.satellites).length;
    if (satellitesParam == null) {
      return new Array(satelliteCount).fill(true);
    } else {
      return decodeSatellites(satellitesParam);
    }
  });

  const parseDateFromURL = (str) => {
    if (!str) return null;
    const parts = str.split('-').map(Number);
    if (parts.length !== 5 || parts.some(isNaN)) return null;
  
    const [year, month, day, hour, minute] = parts;
    return new Date(Date.UTC(year, month - 1, day, hour, minute));
  };

  //initialize start dates from URL
  const [selectedDates, setSelectedDates] = useState(() => {
    const startParam = searchParams.get('start');
    const endParam = searchParams.get('end');

    const start = parseDateFromURL(startParam) || UTCStartDate;
    const end = parseDateFromURL(endParam) || UTCEndDate;
    return [start, end];
  });


  /* Code for updating URL when state (region, date, satellite) changes */
  const updateURL = (newStartDate, newEndDate, newSatellites) => {
    setSearchParams(prev => {
      const params = new URLSearchParams(prev);

      const formatDate = (date) => {
        return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, '0')}-${String(date.getUTCDate()).padStart(2, '0')}-${String(date.getUTCHours()).padStart(2, '0')}-${String(date.getUTCMinutes()).padStart(2, '0')}`;
      };

      if (newStartDate instanceof Date && !isNaN(newStartDate)) {
        params.set('start', formatDate(newStartDate));
      }
      if (newEndDate instanceof Date && !isNaN(newEndDate)) {
        params.set('end', formatDate(newEndDate));
      }
      params.set('sats', encodeSatellites(newSatellites));
      return params;
    });
  }


  //on page load
  useEffect(() => {
    const startParam = searchParams.get('start');
    const endParam = searchParams.get('end');
    const satellitesParam = searchParams.get('sats');

    if (!startParam || !endParam || !satellitesParam) {
      updateURL(selectedDates[0], selectedDates[1], satellites);
    }
  }, []);






  /* Code for choosing satellites */
  const handleOnChange = (position) => {
    var satellitesCopy = [...satellites];
    satellitesCopy[position] = !satellites[position]
    setSatellites(satellitesCopy);
  }


  useEffect(() => {
    var endBound = new Date(selectedDates[0]);
    endBound.setDate(selectedDates[0].getDate() + 1);
    if (selectedDates[1] < selectedDates[0]) {
      // setSelectedDates([selectedDates[0], selectedDates[0]])
      setSelectedDates([selectedDates[0], endBound])
    }
    else {
      getParams({ dates: selectedDates, satellites: null })
    }

  }, [selectedDates, getParams])


  const getStartMaxTime = () => {
    if (UTCStartDate.getTime() === new Date(selectedDates[0].getFullYear(), selectedDates[0].getMonth(), selectedDates[0].getDate()).getTime()) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())
    } else {
      return (new Date()).setHours(23, min = 59)
    }
  }


  const getEndMaxTime = () => {
    if (selectedDates[1] && UTCStartDate.getTime() === new Date(selectedDates[1].getFullYear(), selectedDates[1].getMonth(), selectedDates[1].getDate()).getTime()) {
      return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())
    } else {
      return (new Date()).setHours(23, min = 59)
    }
  }


  const getEndMinTime = () => {
    if (selectedDates[1] && new Date(selectedDates[0].getFullYear(), selectedDates[0].getMonth(), selectedDates[0].getDate()).getTime() === new Date(selectedDates[1].getFullYear(), selectedDates[1].getMonth(), selectedDates[1].getDate()).getTime()) {
      return selectedDates[0]
    } else {
      return (new Date()).setHours(0, min = 0)
    }
  }


  const getEndMaxDate = () => {
    var endBound = new Date(selectedDates[0]);
    endBound.setDate(selectedDates[0].getDate() + 7);
    if (endBound > UTCStartDate) {
      return UTCStartDate;
    }
    else {
      return endBound;
    }
  }


  const handleStartDate = (date) => {
    if (new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime() === new Date(selectedDates[0].getFullYear(), selectedDates[0].getMonth(), selectedDates[0].getDate()).getTime()) {
      setSelectedDates([date, selectedDates[1]])
    } else {
      setSelectedDates([date, null])
    }
  }




  /* Code for choosing all satellites */
  const handleOnAll = () => {
    var pos;
    var satellitesCopy = [...satellites];
    const sats = Object.keys(regions.satellites);

    var all = document.getElementById("all");

    if (all.checked === true) {
      sats.forEach((satId, pos) => {
        satellitesCopy[pos] = all.checked;
        const checkbox = document.getElementById(satId);
        if (checkbox) checkbox.checked = all.checked;
      });
    }
    else {
      for (pos = 0; pos < sats.length; pos++) {
        satellitesCopy[pos] = false;
        document.getElementById(sats[pos]).checked = false;
      }
    }
    setSatellites(satellitesCopy);
  }


  useEffect(() => {
    getParams({ dates: selectedDates, satellites: satellites })
    updateURL(selectedDates[0], selectedDates[1], satellites);
  }, [selectedDates, satellites, getParams])


  const popover = (
    <Popover id="popover-basic">
      {/* <Popover.Header as="h3">Popover right</Popover.Header> */}
      <Popover.Body>
        <ul>
          <li>Select the region to display by using Google Maps zoom and pan tools or by using the Box
            Selection function in the Control Panel (lower right corner). Check the Box Selection box to
            activate and uncheck to deactivate this function.</li>
          <li>Sample product value by clicking on the image</li>
          <li>Toggle the Loop button to start or stop the looping process</li>
          <li>Use the arrows to scroll through the images manually</li>
          <li>Use the slider in the Control Panel to adjust opacity</li>
          <li>Check the Show Counties box to show county boundaries when zoomed in</li>
        </ul>
      </Popover.Body>
    </Popover>
  );

  const Instructions = () => (
    <OverlayTrigger trigger="click" placement="right" overlay={popover}>
      <Button variant="primary" style={{ fontSize: "20px" }}>Instructions</Button>
    </OverlayTrigger>
  );


  //const [startDate, setStartDate] = useState(new Date());
  const years = range(2021, getYear(new Date()) + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];


  return (
    <div>
      {region === "conus"
        ? <p>Images generated using direct broadcast data received at <a href="https://cimss.ssec.wisc.edu/" rel="noreferrer" target="_blank">CIMSS</a>.</p>
        : <p>Images generated using direct broadcast data received at <a href="https://gina.alaska.edu/" rel="noreferrer" target="_blank">GINA</a>.</p>}


      <p><Instructions /></p>


      <h5>
        <a href="https://drive.google.com/file/d/1v_oqSilIN9nXtk3bzc-MmLHayN-4xHiX/view?usp=sharing"
          target="_blank" rel="noreferrer noopener">SFR Quick Guide</a>
      </h5>


      <hr style={{ color: "black" }} />

      <h7>The date range is limited to 7 days.</h7>
      <h5>Start Date</h5>
      <div className="date-picker" style={{ fontSize: "15px" }}>
        <Row>

          <DatePicker

            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
              decreaseYear,
              increaseYear,
              prevYearButtonDisabled,
              nextYearButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button onClick={decreaseYear} disabled={prevYearButtonDisabled}>
                  {"<<"}
                </button>
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                  {"<"}
                </button>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>


                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                  {">"}
                </button>
                <button onClick={increaseYear} disabled={nextYearButtonDisabled}>
                  {">>"}
                </button>
              </div>
            )}

            selected={selectedDates[0]}
            // onChange={(date) => setSelectedDates([date, date])}
            onChange={(date) => handleStartDate(date)}
            // showYearDropdown
            selectsStart
            startDate={selectedDates[0]}
            yearDropdownItemNumber={4}
            minDate={new Date("2021-01-02")}
            maxDate={UTCStartDate}
            showTimeSelect
            timeIntervals={60}
            minTime={(new Date()).setHours(0, min = 0)}
            maxTime={getStartMaxTime()}
            dateFormat="MM/dd/yyyy HH:mm"
            timeFormat="HH:mm"
          />

        </Row>
      </div>

      <div className="day-controls">
        <button
          onClick={() => {
            const prevStartDay = new Date(selectedDates[0]);
            const prevEndDay = new Date(selectedDates[1]);

            if (prevEndDay.getTime() === UTCEndDate.getTime()) {
              prevStartDay.setDate(prevStartDay.getDate() - 1);
              prevStartDay.setHours(0);
        
              prevEndDay.setHours(0);
            } else if (
              prevStartDay.getFullYear() === UTCEndDate.getFullYear() &&
              prevStartDay.getMonth() === UTCEndDate.getMonth() &&
              prevStartDay.getDate() === UTCEndDate.getDate() + 1
            ) {
              prevStartDay.setFullYear(UTCEndDate.getFullYear(), UTCEndDate.getMonth(), UTCEndDate.getDate());
              prevStartDay.setHours(0);
            
              prevEndDay.setTime(UTCEndDate.getTime());
            }
            else {
              prevStartDay.setDate(prevStartDay.getDate() - 1);
              prevStartDay.setHours(0);
        
              prevEndDay.setDate(prevEndDay.getDate() - 1);
              prevEndDay.setHours(0);
            }
            

              setSelectedDates([prevStartDay, prevEndDay])
          }} className="prev-day">
          ← Previous Day
        </button>

        <button
          onClick={() => {
            const nextStartDay = new Date(selectedDates[0]);
            const nextEndDay = new Date(selectedDates[1]);

            nextStartDay.setDate(nextStartDay.getDate() + 1);
            nextStartDay.setHours(0);

            nextEndDay.setDate(nextEndDay.getDate() + 1);

            if (
              nextStartDay.getFullYear() === UTCEndDate.getFullYear() &&
              nextStartDay.getMonth() === UTCEndDate.getMonth() &&
              nextStartDay.getDate() === UTCEndDate.getDate()
            ) {
              nextEndDay.setTime(UTCEndDate.getTime());
            } else {
              nextEndDay.setHours(0);
            }
        
            setSelectedDates([nextStartDay, nextEndDay])
          }} className="next-day">
          Next Day →
        </button>
      </div>


      <h5>End Date</h5>
      <div className="date-picker" style={{ fontSize: "15px" }}>
        <Row>
          <DatePicker

            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                  {"<"}
                </button>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>


                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>


                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                  {">"}
                </button>
              </div>
            )}


            selected={selectedDates[1]}
            onChange={(date) => setSelectedDates([selectedDates[0], date])}
            // showYearDropdown
            selectsEnd
            startDate={selectedDates[0]}
            endDate={selectedDates[1]}
            minDate={selectedDates[0]}
            yearDropdownItemNumber={4}
            // maxDate={UTCdate}
            maxDate={getEndMaxDate()}
            showTimeSelect
            timeIntervals={60}
            minTime={getEndMinTime()}
            maxTime={getEndMaxTime()}
            dateFormat="MM/dd/yyyy HH:mm"
            timeFormat="HH:mm"
          />
        </Row>
      </div>


      <hr style={{ color: "black" }} />


      <Row className='ml-3'>
        <Col><h5>Satellites:</h5></Col>
        <Col>
          <Form.Check
            inline
            id={'all'}
            label="All"
            type={'checkbox'}
            checked={satellites.every(Boolean)}
            style={{ width: "90px", fontSize: "14px" }}
            onChange={() => handleOnAll()}
          />
        </Col>
        <Col></Col>
      </Row>
      <Form>
        {Object.keys(regions.satellites)
          .map((satId, index) => (
            <Form.Check
              key={satId}
              inline
              id={satId}
              label={regions.satellites[satId].checkbox_name}
              type={'checkbox'}
              checked={satellites[index]}
              style={{ width: "90px", fontSize: "14px" }}
              onChange={() => handleOnChange(index)}
            />
          ))}
      </Form>
      <hr style={{ color: "black" }} />

      <Row ><Col style={{ fontSize: "12px"}}>* No NOAA-19 images after 06/16/2025- satellite was decomissioned on 08/13/2025.</Col></Row>
      {/* <Row ><Col className="small">* NOAA-19 was decomissioned on 08/13/2025.</Col></Row> */}

    </div >
  );
}

export default NavRight;



// function Instructions() {
//     const renderTooltip = (props) => (
//       <Tooltip id="button-tooltip" {...props}>
//             <ul>
//                 <li>Select the region to display by using Google Maps zoom and pan tools or by using the Box
//                     Selection function in the Control Panel (lower right corner). Check the Box Selection box to
//                     activate and uncheck to deactivate this function.</li>
//                 <li>Sample product value by clicking on the image</li>
//                 <li>Toggle the Loop button to start or stop the looping process</li>
//                 <li>Use the arrows to scroll through the images manually</li>
//                 <li>Use the slider in the Control Panel to adjust opacity</li>
//                 <li>Check the Show Counties box to show county boundaries when zoomed in</li>
//             </ul>
//       </Tooltip>
//     );
//     return (
//       <OverlayTrigger
//         placement="bottom"
//         delay={{ show: 100, hide: 200 }}
//         overlay={renderTooltip}
//       >
//         <Button variant="success">Display Instructions</Button>
//       </OverlayTrigger>
//     );
//   }



